import {JackpotBetWidgetGradientTextMRGBox} from "./jackpot-bet-widget-gradient-text.mrgreen.box";


export const JackpotBetWidgetGradientTextMRGCisBox = JackpotBetWidgetGradientTextMRGBox;